import { iife } from "./no-topic";

function groupBy<K extends PropertyKey, T>(
  items: Iterable<T>,
  keySelector: (item: T, index: number) => K,
): Partial<Record<K, T[]>> {
  return [...items].reduce(
    (acc, item, index) => {
      const key = keySelector(item, index);
      if (key in acc && Array.isArray(acc[key])) {
        acc[key].push(item);
      } else {
        acc[key] = [item];
      }

      return acc;
    },
    {} as ReturnType<typeof groupBy<K, T>>,
  );
}

function withInvertedProperties<T extends Record<string, PropertyKey>>(
  obj: T,
  castNumberKeys = true,
) {
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => {
      const key_ = castNumberKeys
        ? iife(() => {
            const keyAsNumber = Number(key);
            return isNaN(keyAsNumber) ? key : keyAsNumber;
          })
        : key;

      return [value, key_];
    }),
  ) as Record<T[keyof T], keyof T>;
}

export { groupBy, withInvertedProperties };
